import React from "react";
import {getDisplayName, hoistNonReactStatics} from "@core-ui/utility";
import {BreakpointContext} from "./context";
import {SMALL, MEDIUM, LARGE, XLARGE} from "./breakpoints";
import {BreakpointProviderState} from "./types";

const breakpoints = {
  SMALL,
  MEDIUM,
  LARGE,
  XLARGE,
};

type WithBreakpointProps = BreakpointProviderState & typeof breakpoints;

export const withBreakpoint = (
  mapContextToProps = (mapContextToProps: WithBreakpointProps) =>
    mapContextToProps
) => <P extends WithBreakpointProps = WithBreakpointProps>(
  Component: React.ComponentType<P>
) => {
  const WithBreakpoint = (
    props: Omit<P, keyof WithBreakpointProps>
  ): JSX.Element => (
    <BreakpointContext.Consumer>
      {(breakpointData) => (
        <Component
          {...mapContextToProps({...breakpointData, ...breakpoints})}
          {...(props as P)}
        />
      )}
    </BreakpointContext.Consumer>
  );
  WithBreakpoint.displayName = getDisplayName(Component);
  return hoistNonReactStatics(WithBreakpoint, Component);
};
